import { v4 as uuidv4 } from 'uuid'

const mockData = [
    {
        id: "1",
        status:"not_started",
        title: 'Not Started',
        cards: [
           
        ]
    },
    {
        id: "2",
        status:"todo",
        title: 'To do',
        cards: [
           
        ]
    },
    {
        id: "3",
        status:"in_progress",
        title: 'In progress',
        cards: [
           
        ]
    },
    {
        id: "4",
        status:"dependencies",
        title: 'Awaiting Confirmation',
        cards: [
           
        ]
    },
    {
        id: "5",
        status:"completed",
        title: 'Completed',
        cards: [
           
        ]
    }
]

export default mockData